<template>
  <l-layer-group>
    <l-marker :lat-lng="coords" :fill-color="color">
      <l-icon v-bind="icon">
        <svg
          width="36"
          height="49"
          viewBox="0 0 36 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              d="M31.8293 16.053C31.8293 20.0761 30.1829 23.3421 27.9381 26.5705C25.2439 30.4454 15.9146 44.8378 15.9146 44.8378C15.9146 44.8378 6.58537 30.999 3.89113 26.5705C1.87045 23.2492 0 20.0761 0 16.053C0 7.18719 7.12522 0 15.9146 0C24.704 0 31.8293 7.18719 31.8293 16.053Z"
              :fill="color"
            />
          </g>
        </svg>

        <div class="color-marker-label">
          {{ label }}
        </div>

        <img :src="icon.shadowUrl" alt="shadow" class="shadow-image" />
      </l-icon>
    </l-marker>
  </l-layer-group>
</template>

<script>
import { LIcon, LMarker, LLayerGroup } from "vue2-leaflet";
import { Icon } from "leaflet";
import { HEAT_COLOR } from "@/config/visibility_level";
import { colored } from "@/config/marker";

export default {
  name: "MapColorMarker",
  components: {
    LMarker,
    LIcon,
    LLayerGroup
  },
  props: {
    coords: {
      type: Array,
      required: true
    },
    color: {
      type: String,
      required: false,
      default: HEAT_COLOR.DEFAULT
    },
    label: {
      type: [String, Number],
      required: false
    }
  },
  data() {
    return {
      icon: colored
    };
  },
  created() {
    delete Icon.Default.prototype._getIconUrl;
  }
};
</script>

<style lang="scss">
.color-marker {
  position: relative;

  &::after {
    position: absolute;
    z-index: -1;
    top: 0;
    opacity: 0.25;
    content: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iNDUiIHZpZXdCb3g9IjAgMCAzMiA0NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMxLjgyOTMgMTYuMDUzQzMxLjgyOTMgMjAuMDc2MSAzMC4xODI5IDIzLjM0MjEgMjcuOTM4MSAyNi41NzA1QzI1LjI0MzkgMzAuNDQ1NCAxNS45MTQ2IDQ0LjgzNzggMTUuOTE0NiA0NC44Mzc4QzE1LjkxNDYgNDQuODM3OCA2LjU4NTM3IDMwLjk5OSAzLjg5MTEzIDI2LjU3MDVDMS44NzA0NSAyMy4yNDkyIDAgMjAuMDc2MSAwIDE2LjA1M0MwIDcuMTg3MTkgNy4xMjUyMiAwIDE1LjkxNDYgMEMyNC43MDQgMCAzMS44MjkzIDcuMTg3MTkgMzEuODI5MyAxNi4wNTNaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K);
    filter: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iNDkiIHZpZXdCb3g9IjAgMCAzNiA0OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGRlZnM+CjxmaWx0ZXIgaWQ9ImZpbHRlcjBfZCIgeD0iMCIgeT0iMCIgd2lkdGg9IjM1LjgyOTMiIGhlaWdodD0iNDguODM3OCIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPgo8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwIiByZXN1bHQ9IkJhY2tncm91bmRJbWFnZUZpeCIvPgo8ZmVDb2xvck1hdHJpeCBpbj0iU291cmNlQWxwaGEiIHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAxMjcgMCIvPgo8ZmVPZmZzZXQgZHk9IjIiLz4KPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iMSIvPgo8ZmVDb2xvck1hdHJpeCB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMC4yNSAwIi8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW4yPSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIHJlc3VsdD0iZWZmZWN0MV9kcm9wU2hhZG93Ii8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW49IlNvdXJjZUdyYXBoaWMiIGluMj0iZWZmZWN0MV9kcm9wU2hhZG93IiByZXN1bHQ9InNoYXBlIi8+CjwvZmlsdGVyPgo8L2RlZnM+Cjwvc3ZnPgo=#filter0_d);
  }
}

.color-marker-label {
  position: absolute;
  height: 24px;
  width: 24px;
  border-radius: 50%;
  background: $light;
  top: 4px;
  left: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $grey-darker;
  font-family: $font-family-base;
  font-weight: 500;
  @include font-size(12px);
}

.shadow-image {
  position: absolute;
  top: 7px;
  left: 5px;
  z-index: -1;
  opacity: 0.7;
}
</style>
